
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Register from './components/Register';
import Login from './components/Login';
import Profile from './components/Profile';
import UserList from './components/UserList';
import Questions from './components/Questions';
import BibleView from './components/BibleView';
import PrivateRoute from './routing/PrivateRoute';
import GuestRoute from './routing/GuestRoute';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<div><h1>Добро пожаловать</h1></div>} />
          <Route path="/register" element={<GuestRoute><Register /></GuestRoute>} />
          <Route path="/login" element={<GuestRoute><Login /></GuestRoute>} />
          <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
          <Route path="/users" element={<PrivateRoute><UserList /></PrivateRoute>} />
          <Route path="/questions" element={<PrivateRoute><Questions /></PrivateRoute>} />
          <Route path="/bible" element={<BibleView />} />
          <Route path="/bible/:bookId" element={<BibleView />} />
          <Route path="/bible/:bookId/:chapterNumber" element={<BibleView />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
